import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #4cc5b6;
  border-radius: 10px;
  display: flex;
  gap: 10px;
  padding: 16px;
  width: 100%;

  &.has-error {
    border-color: #cc0000;
  }

  &.bg-white {
    background-color: #fff;
    label {
      color: #000;
    }
  }
`;

export const Label = styled.label`
  font-family: "Source Sans 3";
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  white-space: nowrap;
`;

export const Input = styled.input`
  background-color: transparent;
  border: 0 none;
  font-family: Source Sans 3;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  width: 100%;

  &:focus {
    outline: 0 none;
  }
`;

export const Error = styled.p`
  color: #cc0000;
  display: inline-block;
`;
